import {RqInputPerson} from "../../api/dto/RqInputPerson";
import {RqInputAddress} from "../../api/dto/RqInputAddress";
import {ButtonComponent} from "../../components/common/button/ButtonComponent";
import React from "react";
import {DocumentType, documentTypeToLabel, stringToDocumentType} from "../../domain/verification/DocumentType";
import {InputDocument} from "../../domain/document/InputDocument";

export const ConfirmInformationViewModel = (onConfirmClick: () => void) => {

    const buildFullName = (personalInformation: RqInputPerson): string => {
        return `${personalInformation.firstName} 
        ${personalInformation.middleName ? `${personalInformation.middleName} ${personalInformation.lastName}`
            : `${personalInformation.lastName}`}`
    }

    const buildAddress = (address: RqInputAddress): string => {
        return `${address.street}, ${address.suburb}, ${address.city} ${address.postCode} ${address.country}`
    }

    const buildDocument = (document: InputDocument) => (
        <div>
            {document.documentId && <div>Number: {document.documentId}</div>}
            {document.documentId ? document.additionalInformation.filter(info => info.key !== 'documentId')
                    .map(info => (
                        <div>{info.title}: {info.value}</div>
                    )) :
                document.additionalInformation.map(info => (
                    <div>{info.title}: {info.value}</div>
                ))}
        </div>
    )

    const submit = () => {
        onConfirmClick()
    }

    const buildConfirmInfoBlock =
        (personalInformation: RqInputPerson, address: RqInputAddress, document: InputDocument, show: boolean) => (
            <div className={`info-position header-back-container ${show ? '' : 'hide-important'}`}>
                <div className={`info-container`}>
                    <div className={`font-sm primary-color`}>
                        Personal Information
                    </div>
                    <div className={`info-confirm-container full-border-radius font-sm primary-color`}>
                        <span className={`flex-start capitalize`}>{buildFullName(personalInformation).toLowerCase()}</span>
                        <span className={`flex-start`}>Date of birth: {personalInformation.birthDate}</span>
                    </div>
                    <div className={`font-sm primary-color`}>
                        Address
                    </div>
                    <div className={`info-confirm-container full-border-radius font-sm primary-color`}>
                        <span className={`flex-start capitalize`}>{buildAddress(address).toLowerCase()}</span>
                    </div>
                    <div className={`font-sm primary-color`}>
                        {documentTypeToLabel(stringToDocumentType(document.type!!))}
                    </div>
                    {
                        document.type.toLowerCase() !== DocumentType.NO_ID && (
                            <div className={`info-confirm-container full-border-radius font-sm primary-color`}>
                                <span className={`flex-start`}>{buildDocument(document)}</span>
                            </div>
                        )
                    }
                </div>
                <div className={`width-full info-step-button-container`}>
                    <div className={`font-sm info-document-disclaimer-container primary-color`}>
                        I confirm these details are correct and authorise
                        Emerge Group to verify them.
                    </div>
                    <ButtonComponent label="Submit" onButtonClick={() => submit()}
                                     className={`info-step-button`}
                                     disableOnClick/>
                </div>
            </div>
        )

    return {
        buildConfirmInfoBlock
    }

}